// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1R_eq","loaderOuter":"PageOverlayLoader_loaderOuter__awHsj"};